import React from 'react'
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import StandardCategoryBanner from '../../Core/Banners/StandardCategoryBanner'
// import StandardCategoryFooter from '../../Core/Banners/StandardCategoryFooter'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import { useQuery } from '@apollo/react-hooks'
import blogPostsQuerySingle from './blogPostsQuerySingle.gql'
import ArticlesGridViewer from './Components/ArticlesGridViewer'
import BlogBanner from '../../Core/Banners/BlogBanner'
import { theme } from '../../Theme'

const ArticlesWrapper = styled.div`
   ${theme.below.md} {
      padding-top: 2rem;
   }
   background-color: #e9e9e9;
`

const BlogCategory = ({ category, parents }) => {
   const [getSetting, loadingSettings] = useSiteSettingsQuery()
   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)
   const categoryId = category?.id

   const { data, loading } = useQuery(blogPostsQuerySingle, {
      variables: { id: categoryId },
   })

   const articlesData = constructArticlesData(data, categoryId)

   return (
      <>
         <BlogBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
            isSingleBrand={true}
         ></BlogBanner>
         <ArticlesWrapper className="py-32 px-128">
            <ArticlesGridViewer articlesData={articlesData} loading={loading}/>
         </ArticlesWrapper>
         <RenderCustomElements items={items} />
      </>
   )
}

export default BlogCategory

const constructArticlesData = (data, id) => {
   const subCatsArr = data?.category?.subcategories
   const { name, primaryRoute } = data?.category ?? {}
   const formattedArticlesArr =
      subCatsArr?.reduce((accumulator, obj) => {
         // Include only specific properties in the new object
         accumulator.push({
            id: obj?.id,
            title: obj?.head?.title ? obj?.head?.title : obj?.name,
            articleText: obj?.head?.metaTags[0]?.content,
            imageSrc:obj?.images[3]?.url,
            routePath: obj?.primaryRoute?.path,
         })
         return accumulator
      }, []) ?? []

      return {
         name,
         primaryRoute,
         articles: formattedArticlesArr,
      }
}